import { render, staticRenderFns } from "./examine-detail.vue?vue&type=template&id=570946e5"
import script from "./examine-detail.vue?vue&type=script&lang=js"
export * from "./examine-detail.vue?vue&type=script&lang=js"
import style0 from "./examine-detail.vue?vue&type=style&index=0&id=570946e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports